import { render, staticRenderFns } from "./UserPasswordSettings.vue?vue&type=template&id=43e83be2&"
import script from "./UserPasswordSettings.vue?vue&type=script&lang=js&"
export * from "./UserPasswordSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports